export default __webpack_public_path__ + "static/media/checked.ff7de9e6.svg";